import React, { useState } from 'react';
import DefaultButton from '../default-button/DefaultButton';
import ArrowLeft from '../../assets/icons/ArrowLeft';
import ArrowRight from '../../assets/icons/ArrowRight';
import Plus from '../../assets/icons/Plus';
import Cross from '../../assets/icons/Cross';
import { EventType } from '../../misc/types';
import { isSameDay } from 'date-fns';
import { useHookstate } from '@hookstate/core';
import InputField from '../input-field/InputField';
import { onInputChangeNative } from '../../misc/utils';
import { Avatar } from '../Avatar';
import { useGlobalMiscState } from '../../stores/misc';

type CalendarPropsType = {
  localEvents: EventType[];
  allUsersWithAppointments?: any[];
  mode?: string;
  selectedPsychologist?: any;
  setSelectedPsychologist?: React.Dispatch<React.SetStateAction<any>>;
};

const Calendar = ({ localEvents, allUsersWithAppointments, mode = "self", selectedPsychologist, setSelectedPsychologist }: CalendarPropsType) => {
  const miscState = useGlobalMiscState();
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  //const selectedPsychologist = miscState.get('psychologyAdminSelectedPsychologist') || {};
  const search = state.search || "";
  const now = new Date();

  const [currentMonth, setCurrentMonth] = useState(now.getMonth());
  const [currentYear, setCurrentYear] = useState(now.getFullYear());

  const [selectedDays, setSelectedDays] = useState<number[]>([now.getDate()]);

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

  const isAdmin = mode === "admin";

  const getEventCountForDay = (day: number) => {
    const dayDate = new Date(currentYear, currentMonth, day);
    return localEvents.filter((ev) => isSameDay(ev.day, dayDate)).length;
  };

  const selectPsychologist = (u: any) => () => {
    // console.log(u);
    // miscState.set('psychologyAdminSelectedPsychologist', u);
    //@ts-ignore
    setSelectedPsychologist(u);
  }

  const toggleDay = (day: number) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const createVacation = () => {
    alert('Vacation created!');
  };

  const deleteVacation = () => {
    setSelectedDays([]);
    alert('Vacation deleted!');
  };

  const goToPreviousMonth = () => {
    setSelectedDays([]);
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear((prev) => prev - 1);
    } else {
      setCurrentMonth((prev) => prev - 1);
    }
  };

  const goToNextMonth = () => {
    setSelectedDays([]);
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear((prev) => prev + 1);
    } else {
      setCurrentMonth((prev) => prev + 1);
    }
  };

  const renderDayButton = (day: number) => {
    const eventCount = getEventCountForDay(day);

    let style = 'py-0.5 text-sm font-medium transition-colors';

    if (eventCount === 1) {
      style += 'bg-gray-200 text-gray-800';
    } else if (eventCount >= 2) {
      style += ' bg-gray-400 text-white rounded-full';
    } else {
      style += 'bg-transparent text-black';
    }

    return (
      <button key={day} onClick={() => toggleDay(day)} className={style}>
        {day}
      </button>
    );
  };

  return (
    <div className='flex flex-col gap-4'>
      <div className={`p-6 bg-white rounded-lg shadow-md ${!isAdmin ? 'flex-1' : ''}`}>
        <div className="flex justify-between items-center mb-4">
          <DefaultButton
            additionalStyle="border-none text-[#5F6B88] w-[24px] h-[24px]"
            Icon={ArrowLeft}
            onClick={goToPreviousMonth}
          />
          <h2 className="text-lg font-semibold text-gray-800">
            {new Date(currentYear, currentMonth).toLocaleDateString('ru-RU', {
              month: 'long',
              year: 'numeric',
            })}
          </h2>
          <DefaultButton
            additionalStyle="border-none text-[#5F6B88] w-[24px] h-[24px]"
            Icon={ArrowRight}
            onClick={goToNextMonth}
          />
        </div>

        <div className="grid grid-cols-7 gap-2 text-center mb-1">
          {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((day) => (
            <div key={day} className="font-medium text-gray-600">
              {day}
            </div>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-2 text-center">
          {[
            ...Array(new Date(currentYear, currentMonth, 1).getDay() === 0
              ? 6
              : new Date(currentYear, currentMonth, 1).getDay() - 1).fill(null),
            ...Array.from({ length: daysInMonth }, (_, i) => i + 1)
          ].map((day, idx) =>
            day === null ? <div key={`empty-${idx}`} /> : renderDayButton(day)
          )}
        </div>

        {/* <div className="my-5 flex flex-col gap-2">
        <DefaultButton
          buttonText="Создать отпуск"
          Icon={Plus}
          additionalStyle="w-full text-gray-500 border border-gray-300 py-2"
          onClick={createVacation}
        />
        <DefaultButton
          buttonText="Удалить Отпуск"
          Icon={Cross}
          additionalStyle="w-full text-gray-500 border border-gray-300 py-2"
          onClick={deleteVacation}
        />
      </div> */}
      </div>
      {isAdmin && (
        <div className='flex flex-col flex-1 bg-white rounded-xl pt-4 pl-4 pr-2'>
          <div className='flex flex-row pt-2 pl-2 pr-4 pb-4 items-center justify-center border-b border-valley-background-blue'>
            <InputField
              type="text"
              id="psychologists-search"
              placeholder='Поиск по психологам'
              handleChange={onInputChangeNative(localState, "search")}
              value={search}
              additionalClassName="bg-valley-background-blue py-3 px-4 rounded-lg"
            />
          </div>
          <div className='flex flex-col flex-1 overflow-y-auto'>
            {allUsersWithAppointments
              ?.filter(u => {
                const queryLc = search.toLowerCase()
                return u.json_saved_data.email.toLowerCase().includes(queryLc) ||
                  u.json_saved_data.firstname.toLowerCase().includes(queryLc) ||
                  u.json_saved_data.lastname.toLowerCase().includes(queryLc)
              })
              ?.map(u => {
                const isSelected = selectedPsychologist?.id === u.id
                return (
                  <div className='flex flex-row py-1.5'>
                    <div className={`flex flex-row flex-1 cursor-pointer py-1.5 gap-3 items-center px-2 rounded-lg ${isSelected ? 'bg-valley-main' : ''}`} onClick={selectPsychologist(u)}>
                      <Avatar user={u} />
                      <span className={`font-medium text-[15px] leading-[19.5px] ${isSelected ? 'text-white' : 'text-valley-black'}`}>
                        {u.json_saved_data.lastname} {u.json_saved_data.firstname}
                      </span>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Calendar;
